/**
 * Node.js module for Forge.
 *
 * @author Dave Longley
 *
 * Copyright 2011-2016 Digital Bazaar, Inc.
 */
module.exports = {
  // default options
  options: {
    usePureJavaScript: false
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/firebase-admin/node_modules/node-forge/lib/forge.js
// module id = z+Sz
// module chunks = 0